import { Component } from '@angular/core';
import {
  IPE_SAUDE_FLICKR_LINK,
  IPE_SAUDE_INSTAGRAM_LINK,
  IPE_SAUDE_X_LINK,
  IPE_SAUDE_YOUTUBE_LINK
} from '../../constants/urls';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-footer-social-medias',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer-social-medias.component.html',
  styleUrl: './footer-social-medias.component.scss'
})
export class FooterSocialMediasComponent {
  public socialLinks = [
    { name: 'X', url: IPE_SAUDE_X_LINK, icon: 'assets/images/x.svg' },
    { name: 'Flickr', url: IPE_SAUDE_FLICKR_LINK, icon: 'assets/images/Flickr.svg' },
    { name: 'Instagram', url: IPE_SAUDE_INSTAGRAM_LINK, icon: 'assets/images/Instagram.svg' },
    { name: 'YouTube', url: IPE_SAUDE_YOUTUBE_LINK, icon: 'assets/images/YouTube.svg' }
  ];
}
